<template>
  <div class="EntryformVue">
    <div class="wrap">
      <!--content start-->
      <div class="content entry-content content-entryform">
        <!--banner-->
        <div class="et-banner dl-banner">
          <img v-if="route" :src="route" alt=""/>
          <i class="et-modal-white"></i>
        </div>

        <div class="et-tabinner">
          <div class="et-tabhead">

            <span class="et-back" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.form_back&&detailsTxte.page_config.form_back.is_show=='1'">
              <i class="icon-back"></i>
              <a v-bind:href="detailsTxte.page_config.form_back.url">{{detailsTxte.page_config.form_back.title}}</a>
            </span>
            <span class="et-back" @click="detail" v-else>
              <i class="icon-back"></i>
              详情
            </span>

            <div class="et-tabtn">
              <div class="et-tabtn" id="but-tabtn">
                <span :class="category?'btn-et-form et-form-on':btn-et-form" @click="form">
                  <i class="icon-form"></i>表单
                </span>

                <span :class="category?'btn-et-form':'btn-et-form et-form-on'" @click="xz" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.attention_title&&detailsTxte.page_config.attention_title.is_show=='1'">
                  <i class="icon-notice"></i>
                  {{detailsTxte.page_config.attention_title.title}}
                </span>

                <span :class="category?'btn-et-form':'btn-et-form et-form-on'" @click="xz" v-else>
                  <i class="icon-notice"></i>须知
                </span>

              </div>
            </div>
          </div>
          <!-- <div v-show="category">
            <Notice v-if="detailsTxte" :detailsTxte="detailsTxte"></Notice>
          </div>
          <div v-show="!category">
            <SignUp v-if="detailsTxte" :detailsName="detailsTxte"></SignUp>
          </div> -->

           <router-view :detailsTxte="detailsTxte" :userId="userId"></router-view>
        </div>

      </div>
      <!--content end-->

      <!--footer-->
      <PointFooter v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.cctvheader&&detailsTxte.page_config.cctvheader.is_show!=0"></PointFooter>
    </div>

    <!--上传过程-->
    <div class="process-modal large-info-modal modal fade" id="processModal" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top:0">
          <div class="modal-body">
            <div class="modal-inner">
              <p class="pl-num">已完成：<span>85</span>%</p>

              <div class="pl-progress">
                <div class="pl-gro-bar" style="width:80%"></div>
              </div>
              <div class="pl-ms-box">
                <p>总大小：<span class="SizeBox">20</span>M</p>

                <p>已上传：<span class="SecondBox">2</span>M</p>

                <!--  <p>时间：<span class="TimeBox">2</span>秒</p>-->
              </div>
              <a href="javascript:void(0);" class="btn-pl-giveup btn-pl-start" @click="CloseUpload">取&nbsp;&nbsp;消</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--报名完成-->
    <div class="entry-modal large-info-modal modal fade" id="entryModal" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 50px">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-man"></i>

              <p class="el-txt">{{modalTit}}</p>
              <p style="color:#666;text-align:center;">参与ID：<span style="color:#cf5454">{{userId}}</span></p>
              <!--  <router-link tag="a" data-dismiss="modal" class="el-avt" to="/myActivity"><i class="icon-entry"></i>进入我的活动查看进度
                </router-link>-->
              <a href="javascript:void(0);" class="el-avt" @click="myActivitys" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.form_back&&detailsTxte.page_config.form_back.is_show!='1'"><i class="icon-entry"></i>进入我的活动查看进度</a>

              <a v-bind:href="detailsTxte.page_config.form_back.url" class="btn-el-red btn-el-continue" style="font-size: 16px" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.form_back&&detailsTxte.page_config.form_back.is_show=='1'"
                 >{{detailsTxte.page_config.form_back.title}}</a>

              <a href="javascript:void(0);" v-else class="btn-el-red btn-el-continue" style="font-size: 16px"  @click="myActivity">继续参与</a>


              <!-- <router-link tag="a" class="btn-el-red btn-el-continue" to="/myActivity">继续参与</router-link>-->
              <a href="javascript:void(0);" style="font-size: 16px" class="btn-el-red btn-el-share"
                 @click="share">分享</a>
              <ul class="share" style="display: none;text-align: center;padding-left: 3px">
                <span id="share_1" data-mode="prepend" data-image="" data-sites="weibo,qq,qzone"></span>
              </ul>
              <div id="nativeShare"></div>
              <!-- <div class="el-bottom">
                 <router-link tag="a" data-dismiss="modal" to="/home">爱秀首页</router-link>
                 <a href="javascript:void(0);" @click="Continue">活动报名</a>
                 <router-link tag="a" data-dismiss="modal" to="/find">活动官网</router-link>
               </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   弹出框-->
    <div class="entry-modal large-info-modal modal fade" id="Alert" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="text-align: center">
          <div class="modal-body">
            <p class="Prompt-p">请确定信息是否填写完成！</p>
            <button class="buttonZ buttonDiv" data-dismiss="modal">确&nbsp;&nbsp;定</button>
          </div>
        </div>
      </div>
    </div>
    <!--   弹出框错误提示-->
    <div class="entry-modal large-info-modal modal fade" id="AlertName" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="text-align: center">
          <div class="modal-body">
            <p class="Prompt-p">请选择上传文件</p>
            <button class="buttonZ buttonDiv" data-dismiss="modal">确&nbsp;&nbsp;定</button>
          </div>
        </div>
      </div>
    </div>
    <!--   是否参与过-->
    <div class="entry-modal large-info-modal modal fade" id="participate" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="text-align: center">
          <div class="modal-body">
            <p class="Prompt-p">您已经参与过该活动！</p>
            <button class="buttonZ buttonDiv">确&nbsp;&nbsp;定</button>
          </div>

        </div>
      </div>
    </div>
    <!--提示-->
    <div class="samll-info-modal modal fade" id="chatModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-modal"></i>

              <p class="info-mess">留言发布成功啦！</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--登录-->
    <div class="modal-confim large-info-modal modal fade" id="login_Alert" role="dialog" aria-hidden="true"
         attr-type="load">
      <div class="modal-dialog" role="document" style="margin-top: 0;width: 100%;height: 100%;">
        <div class="modal-content" style="left: -1%;top: -1%;width: 102%;height: 102%">
          <div class="modal-body">
            <LoginAler></LoginAler>
          </div>
        </div>
      </div>
    </div>
    <!--分享-->
    <div class="shart" @click="shareHide">
      <img :src="globalUrl + 'static/dist/img/weixin.png'" alt="">
    </div>
  </div>
</template>

<script>
  import footer from './template/footer.vue';
  import loginAler from './loginAler.vue'
  import notice from './entryform/notice.vue'
  import signUp from './entryform/signUp.vue'

  export default {
    data() {
      return {
        prompt: '',
        category: true,
        route: '',
        id: '',
        btn: '',
        et: '',
        detailItem: null,
        detailsTxte: null,
        audit_level:2,
        globalUrl: API.GlobalUrl,
        modalTit: '信息已提交，感谢您的参与！',
        stashRoute: {},
        userId: '',
      }
    },
    methods: {
      //操作按钮事件
      share() {
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (isWeixin) {
          $('.shart').show()
        }
      },
      shareHide() {
        $('.shart').hide()
      },
      form() { //表单
        this.category = true;
        //console.log(this.route,this.id)
         // this.$router.replace({name: 'Notice', params: {id: this.id,route: this.route,init: 1}});
         this.$router.replace({...this.stashRoute});
      },
      xz() { //须知
        this.category = false;
         this.$router.replace({name: 'SignUp', params: {id: this.id,init: 2}})
      },
      detail() {
        this.$router.push({name: 'Detail', params: {id: this.id}})
      },
      Continue() {   //继续参与
        $('#entryModal').modal('hide');
        window.location.reload();
      },
      CloseUpload() {  //上传进度弹窗关闭  取消上传
        $('#processModal').modal('hide');
      },
      myActivity() {//继续参与
        var that = this;
        $('#entryModal').modal('hide');
        this.$router.replace({name: 'myActivity_MyParticipate', params: {id: that.id}})
      },
      myActivitys() {//查看
        var that = this;
        $('#entryModal').modal('hide');
        this.$router.replace({name: 'myActivity_MyParticipate', params: {id: 0}})
      }
    },
    components: {   //渲染页面
      PointFooter: footer,
      LoginAler: loginAler,
      Notice: notice,
      SignUp: signUp
    },
    created: function () {
      // console.log(this.$route);
      this.stashRoute = this.$route;
      this.id = this.$route.params.id;
      this.init = this.$route.params.init;
      var that = this;
       if(window.isThisClient('cbox')){
        console.log("entryform");
         that.cboxregisterhandler();
      }
      that.userId = that.getCookie('userSeqId') || '';
      //100131分享
      if(that.id=="100131"){
        that.modalTit = '全家福上传成功！点击分享按钮，邀请您的朋友参与活动吧！'
      }

      if (!this.id) {
        this.$router.push({name: 'Home'})
      }
      // 判断安卓机去掉动画
      that.isAndroid();
      //分享微信
      this.$http.get(API.GetActivitieById, {params: {id: that.id}})
        .then(function (res) {
            // console.log(res,'entryform');
          if (res.code == 0) {
            if (!res.data || res.data.length == 0) {
              that.$router.push({name: 'HomeIndex'})
            }
            that.detailsTxte = res.data;
            if(that.detailsTxte.page_config.wuxicheck && that.detailsTxte.page_config.wuxicheck.is_show==0){
                that.audit_level = 0;
            }
            that.route = that.detailsTxte.playbill.playbill;
            var dataTime = new Date(that.detailsTxte.end_time).getTime() / 1  - new Date().getTime();
            var startData = new Date(that.detailsTxte.start_time).getTime() - new Date().getTime();

            if (dataTime < 0 ||startData > 0 || that.detailsTxte.type == 1) {//type==1???
              that.$router.push({name: 'Detail', params: {id: that.id}});
            }

            //分享微信
            var title = '', desc = '';
            if (that.detailsTxte.share_config) {
              var activity = that.detailsTxte.share_config.activity;
              if (activity && activity.share_title) {
                title = activity.share_title
              } else if (that.detailsTxte.share_config.share_title) {
                title = that.detailsTxte.share_config.share_title;
              } else {
                title = that.detailsTxte.title;
              }
              if (activity && activity.share_contents) {
                desc = activity.share_contents
              } else if (that.detailsTxte.share_config.share_contents) {
                desc = that.detailsTxte.share_config.share_contents
              } else {
                desc = that.detailsTxte.description
              }
            } else {
              title = that.detailsTxte.title;
              desc = that.detailsTxte.description
            }
            document.title = title;
            let metas = $('head').children('meta');
            metas[1].content = desc;
            var img = '';
            if (that.detailsTxte.share_config && that.detailsTxte.share_config.activity  && that.detailsTxte.share_config.activity.share_pic) {
              img = that.detailsTxte.share_config.activity.share_pic
            } else if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
              img = that.detailsTxte.playbill.playbill_h5
            }
            
            var dataName = {
              title: title,  //分享标题
              desc: that.removeTAG(desc, 110),//metas[1].content,//分享简介(内容)
              imgAddress: img,//分享图片地址
              Retain: '',//保留
              url: API.UrlName + 'detail/' + that.id//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
            };
            that.weixinShare(dataName)
          }
        });
    },
    mounted: function () {
      //操作DOM
      //setTimeout(function(){
      // _vjTrack('')
      //},500)
      var that = this
      var ua = navigator.userAgent.toLowerCase()

      function is_uc() {
        if(navigator.userAgent.indexOf('UCBrowser') > -1) {
          return true;
        } else {
          return false;
        }
      }

      function is_qq() {
        if(ua.indexOf('mqqbrowser')> -1 && ua.indexOf(" qq")<0){
          return true;
        } else {
          return false;
        }
      }

      setTimeout(function () {
        // $('#entryModal').modal('show')
        //判断是否是微信
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (!isWeixin) {
          //判断是否是uc浏览器 或者 qq浏览器
          if (is_uc() || is_qq()) {
            var config = {
              url: API.UrlName + 'detail/' + that.id,// 分享的网页链接
              title: that.detailsTxte.title,// 标题
              desc: that.removeTAG(that.detailsTxte.description,100),// 描述
              img: that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill,// 图片
              img_title: '',// 图片标题
              from: API.UrlName // 来源
            };
            var share_obj = new nativeShare('nativeShare', config);
            $('.btn-el-share').hide()
            $('.share').hide()
          }else{
            $('.btn-el-share').hide()
            $('.share').show()
          }

        }
        $('#share_1').share({
          url:  API.UrlName + 'detail/' + that.id
        });
        var banWimg = $('.dl-banner').width();
        var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
        $('.dl-banner img').css({width: banWimg, height: banHimg, visibility: 'visible'});
      }, 500)
    }
  }
</script>
<style>
  @font-face {
    font-family: "socialshare";
    src: url("../../static/lib/fonts/iconfont.eot");
    src: url("../../static/lib/fonts/iconfont.eot?#iefix") format("embedded-opentype"),
    url("../../static/lib/fonts/iconfont.woff") format("woff"),
    url("../../static/lib/fonts/iconfont.ttf") format("truetype"),
    url("../../static/lib/fonts/iconfont.svg#iconfont") format("svg")
  }

  .social-share {
    font-family: "socialshare" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale
  }

  .social-share * {
    font-family: "socialshare" !important
  }

  .social-share .icon-tencent:before {
    content: "\f07a"
  }

  .social-share .icon-qq:before {
    content: "\f11a"
  }

  .social-share .icon-weibo:before {
    content: "\f12a"
  }

  .social-share .icon-wechat:before {
    content: "\f09a"
  }

  .social-share .icon-douban:before {
    content: "\f10a"
  }

  .social-share .icon-heart:before {
    content: "\f20a"
  }

  .social-share .icon-like:before {
    content: "\f00a"
  }

  .social-share .icon-qzone:before {
    content: "\f08a"
  }

  .social-share .icon-linkedin:before {
    content: "\f01a"
  }

  .social-share .icon-diandian:before {
    content: "\f05a"
  }

  .social-share .icon-facebook:before {
    content: "\f03a"
  }

  .social-share .icon-google:before {
    content: "\f04a"
  }

  .social-share .icon-twitter:before {
    content: "\f06a"
  }

  .social-share a {
    position: relative;
    text-decoration: none;
    margin: 4px;
    display: inline-block;
    outline: none
  }

  .social-share
  .social-share-icon {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;
    font-size: 20px;
    border-radius: 50%;
    line-height: 32px;
    border: 1px solid #666;
    color: #666;
    text-align: center;
    vertical-align: middle;
    transition: background 0.6s ease-out 0s
  }

  .social-share .social-share-icon:hover {
    background: #666;
    color: #fff
  }

  .social-share .icon-weibo {
    color: #ff763b;
    border-color: #ff763b
  }

  .social-share .icon-weibo:hover {
    background: #ff763b
  }

  .social-share .icon-tencent {
    color: #56b6e7;
    border-color: #56b6e7
  }

  .social-share .icon-tencent:hover {
    background: #56b6e7
  }

  .social-share .icon-qq {
    color: #56b6e7;
    border-color: #56b6e7
  }

  .social-share .icon-qq:hover {
    background: #56b6e7
  }

  .social-share .icon-qzone {
    color: #FDBE3D;
    border-color: #FDBE3D
  }

  .social-share .icon-qzone:hover {
    background: #FDBE3D
  }

  .social-share .icon-douban {
    color: #33b045;
    border-color: #33b045
  }

  .social-share .icon-douban:hover {
    background: #33b045
  }

  .social-share .icon-linkedin {
    color: #0077B5;
    border-color: #0077B5
  }

  .social-share .icon-linkedin:hover {
    background: #0077B5
  }

  .social-share .icon-facebook {
    color: #44619D;
    border-color: #44619D
  }

  .social-share .icon-facebook:hover {
    background: #44619D
  }

  .social-share .icon-google {
    color: #db4437;
    border-color: #db4437
  }

  .social-share .icon-google:hover {
    background: #db4437
  }

  .social-share .icon-twitter {
    color: #55acee;
    border-color: #55acee
  }

  .social-share .icon-twitter:hover {
    background: #55acee
  }

  .social-share .icon-diandian {
    color: #307DCA;
    border-color: #307DCA
  }

  .social-share .icon-diandian:hover {
    background: #307DCA
  }

  .social-share .icon-wechat {
    position: relative;
    color: #7bc549;
    border-color: #7bc549
  }

  .social-share .icon-wechat:hover {
    background: #7bc549
  }

  .social-share .icon-wechat .wechat-qrcode {
    display: none;
    border: 1px solid #eee;
    position: absolute;
    z-index: 9;
    top: -205px;
    left: -84px;
    width: 200px;
    height: 192px;
    color: #666;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px 10px #aaa;
    transition: all 200ms;
    -webkit-tansition: all 350ms;
    -moz-transition: all 350ms
  }

  .social-share .icon-wechat .wechat-qrcode.bottom {
    top: 40px;
    left: -84px
  }

  .social-share .icon-wechat .wechat-qrcode.bottom:after {
    display: none
  }

  .social-share .icon-wechat .wechat-qrcode h4 {
    font-weight: normal;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    background-color: #f3f3f3;
    margin: 0;
    padding: 0;
    color: #777
  }

  .social-share .icon-wechat .wechat-qrcode .qrcode {
    width: 105px;
    margin: 10px auto
  }

  .social-share .icon-wechat .wechat-qrcode .qrcode table {
    margin: 0 !important
  }

  .social-share .icon-wechat .wechat-qrcode .help p {
    font-weight: normal;
    line-height: 16px;
    padding: 0;
    margin: 0
  }

  .social-share .icon-wechat .wechat-qrcode:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -6px;
    bottom: -13px;
    width: 0;
    height: 0;
    border-width: 8px 6px 6px 6px;
    border-style: solid;
    border-color: #fff transparent transparent transparent
  }

  .social-share .icon-wechat:hover .wechat-qrcode {
    display: block
  }

  .shart {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .shart img {
    width: 65%;
    float: right;
    height: auto;
  }
</style>




// WEBPACK FOOTER //
// src/components/entryform.vue